<template>
  <v-dialog v-model="dialog" max-width="768">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="ma-auto" v-bind="attrs" v-on="on" @click="emitOpen" block>
        <v-icon>mdi-file-chart-outline</v-icon>&nbsp;Catálogos
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="text-h5 indigo lighten-4">
        Catálogo de productos
        <v-spacer></v-spacer>
        <v-btn icon outlined @click="emitClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-list dense rounded>
          <v-list-item v-for="(l, i) in links" :key="i">
            <v-row class="mt-1">
              <v-col
                cols="12"
                md="6"
                class="d-flex justify-center justify-md-start align-center py-0"
              >
                <v-icon>mdi-package-variant</v-icon>&nbsp;
                <span>{{ l.attributes.nombre }}</span>
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="
                  d-flex
                  justify-center justify-lg-end
                  align-center
                  py-lg-0
                "
              >
                <v-btn
                  class="red lighten-2 mr-1"
                  fab
                  small
                  @click="
                    sendMail(l);
                    sendMailRef = true;
                  "
                >
                  <v-icon>mdi-email</v-icon>
                </v-btn>
                <v-btn
                  class="green lighten-4"
                  fab
                  small
                  @click="sendWhats(l.attributes.archivo.data.attributes.url)"
                >
                  <v-icon>mdi-whatsapp</v-icon>
                </v-btn>
                <v-btn
                  class="ml-1"
                  color="accent"
                  fab
                  small
                  @click="download(l.attributes.archivo.data.attributes.url)"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item v-if="links.length == 0">
            <v-list-item-title
              >No hay elementos para mostrar (&gt;.&lt;)</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { httpGet, sendMail } from "@/services/apiService";
import { emailRegex, phoneRegex } from "@/helpers/formHelpers";
export default {
  props: {
    dialog_ref: Boolean,
  },
  data() {
    return {
      links: [],
      sendMailRef: false,
      fileId: null,
      message: "",
    };
  },
  methods: {
    async getCatalogData() {
      const { data } = await httpGet("/catalogos?populate=*");
      this.links = data?.data;
    },
    emitClose() {
      this.$emit("onClose");
    },
    emitOpen() {
      this.$emit("onOpen");
    },
    async sendMail(cat) {
      const valid = emailRegex.test(this.email);
      if (valid == false) {
        this.$toasted.show(
          "El correo ingresado en el cotizador no es válido.",
          { type: "warning" }
        );
        return;
      }
      this.message = `Buen día estimado ${
        this.clientName
      },\nAdjunto en el presente correo el catálogo solicitado, quedamos atentamente a sus órdenes para cualquier duda y/o aclaración al respecto.\nReciba un cordial saludo.\n\n- ${
        JSON.parse(sessionStorage.getItem("user"))["nombre_completo"]
      }`;
      const { data } = await sendMail({
        data: {
          asunto: "Catálogo",
          email: this.email,
          body: this.message,
          fileURL: cat.attributes.archivo.data.attributes.url,
          filename: cat.attributes.archivo.data.attributes.name,
          fileMime: cat.attributes.archivo.data.attributes.mime,
        },
      });
      this.$toasted.show(data?.message, {
        type: "success",
      });
      this.emitClose();
    },
    sendWhats(doc) {
      const valid = phoneRegex.test(this.phone);
      if (valid == false) {
        this.$toasted.show(
          "El teléfono ingresado en el cotizador no es válido.",
          { type: "warning" }
        );
        return;
      }
      const mod = doc.replace("http://", "https://");
      window.open(mod, "_blank");
      setTimeout(() => {
        this.message = `Buen día ${this.clientName}, agradecemos su preferencia y con el gusto de saludarle le enviamos el catálogo solicitado`;
        window.open(
          `https://api.whatsapp.com/send?phone=52${this.phone}&text=${this.message}.`,
          "_blank"
        );
        this.emitClose();
      }, 1000);
    },
    download(url) {
      if (url == null) {
        return;
      }
      const mod = url.replace("http://", "https://");
      window.open(mod, "_blank");
    },
  },
  computed: {
    dialog: {
      get() {
        return this.dialog_ref;
      },
      set(newValue) {
        return newValue;
      },
    },
    email() {
      return this.$store.state.client.email;
    },
    phone() {
      return this.$store.state.client.phone;
    },
    clientName() {
      return (
        this.$store.state.client.selectedClient?.attributes?.nombre ?? "cliente"
      );
    },
  },
  created() {
    this.getCatalogData();
  },
};
</script>